import { routePath } from '@/app/routes/route-meta';
import { toGeoSlug } from '@/lib/displays/geoSlug';
import { stateSlug } from '@/lib/usStates';
import { isPlaceQuery } from '@/lib/displays/discovery';

const displayMapPath = () => routePath('display-map');

export const buildDisplayMapPath = (query = ''): string =>
  `${displayMapPath()}${query ? `?${query}` : ''}`;

export { toGeoSlug };

/**
 * State browse path from any raw state value the DB holds ("TX", "Texas",
 * "TX - Texas") — falls back to a plain geo slug for non-US values so links
 * never 404 outright. Two-word states are percent-encoded ("new%20york") to
 * match the sitemap and canonical URLs; a raw space is not a valid href.
 */
export const buildStateDisplayPath = (stateValue: string): string => {
  const slug = stateSlug(stateValue) ?? toGeoSlug(stateValue);
  return routePath('display-state-browse').replace(':state', encodeURIComponent(slug));
};

export const buildCityDisplayPath = (stateValue: string, city: string): string =>
  `${buildStateDisplayPath(stateValue)}/${toGeoSlug(city)}`;

// These land on the photo discovery page; /displays hands holidays other than
// Christmas/Halloween (and any map-only params) off to the map itself.
/** A ZIP or "City, ST" goes straight to the map; anything else is a text search on /displays. */
export const buildDisplaySearchPath = (query: string): string =>
  isPlaceQuery(query)
    ? buildDisplayMapPath(`q=${encodeURIComponent(query.trim())}`)
    : `${routePath('displays')}?q=${encodeURIComponent(query.trim())}`;

export const buildDisplayHolidayPath = (holiday: string): string =>
  `${routePath('displays')}?holiday=${encodeURIComponent(holiday)}`;

export const buildDisplaySequencesSearchPath = (displayId?: number): string => {
  const isValidDisplayId = Number.isInteger(displayId) && Number.isFinite(displayId) && displayId > 0;
  return isValidDisplayId
    ? `${routePath('sequence-search')}?display=${displayId}`
    : routePath('sequence-search');
};
